<template>
  <EventDefault/>
</template>

<script>
import EventDefault from './EventDefault'
export default {
  components: {
    EventDefault
  },
  data () {
    return {
      programId: Number(this.$route.query.programId)
    }
  },
  created () {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/daoba-match/views/event/EventHome.vue